export default "__VITE_ASSET__CcZ5OcqN__"